/** Reads every page of a total-counted listing; stops on a short page or once `total` is reached. */
export const fetchAllPages = async <T>(
    fetchPage: (offset: number) => Promise<{ items: T[]; total: number }>,
    pageSize: number,
): Promise<T[]> => {
    const all: T[] = [];
    for (let offset = 0; ; offset += pageSize) {
        const { items, total } = await fetchPage(offset);
        all.push(...items);
        if (items.length < pageSize || offset + items.length >= total) return all;
    }
};

/** Runs `send` over consecutive chunks of at most `size` ids, one after another, and joins the answers. */
export const sendInChunks = async <R>(
    ids: string[],
    size: number,
    send: (chunk: string[]) => Promise<R[]>,
): Promise<R[]> => {
    const results: R[] = [];
    for (let i = 0; i < ids.length; i += size) results.push(...(await send(ids.slice(i, i + size))));
    return results;
};
